module.exports = __webpack_public_path__ + "img/guide-card.6c1cd42e.png";